var map = {
	"./amex.svg": "a834",
	"./animal.svg": "f159",
	"./bus.svg": "db9f7",
	"./en_compt.svg": "27b6",
	"./low_car.svg": "f5c9",
	"./mad.svg": "a137",
	"./monospace.svg": "90da",
	"./person.svg": "857b",
	"./taxi.svg": "fe55",
	"./test.svg": "d859",
	"./vip.svg": "514d",
	"./wheelchair.svg": "1f77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4125";